import { createRouter, createWebHistory } from 'vue-router'
import { updateLogin, proverkaCookies, activity } from '@/controlles/auth'

import general from './general'
import catalog from './сatalog'
import userview from './user'
import client from './client'
import warehouse from './warehouse'
import delivery from './delivery'
import catalogostatok from './сatalogostatok'
import order from './order'
import manager from './manager'
import analytics from './analytics'

const routes = [
  ...catalog,
  ...general,
  ...userview,
  ...client,
  ...warehouse,
  ...delivery,
  ...catalogostatok,
  ...order,
  ...manager,
  ...analytics
]

const router = createRouter({
  history: createWebHistory(),
  routes
})




router.beforeEach(async (to, from) => {

  /* if (to.name === 'manager-addnew-id') {
    return true
  }
  
  if (to.path === '/manager/addnew/') {
    return { path: '/' }
  } */

    
  if (!activity.value) {
    if (proverkaCookies()) {
      try {
        await updateLogin()
        return true
      } catch (e) {
        return { name: 'auth' }
      }
    }
    if (to.meta.auth) { return true }
    return { name: 'auth' }
  }
})

router.onError((error) => {
  if (error.message.includes('Transition was skipped') || 
      error.name === 'AbortError') {

    return
  }
  console.error('Router error:', error)
})

export default router
